import { Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import RulebookTokenText from "@/components/Rulebook/RulebookTokenText";
import type { RenderTokenChip } from "@/components/Rulebook/tokenChipTint";

export type RulebookProfileMeterLevel = {
  label: string;
  caption?: string;
  instruction?: string;
};

type RulebookProfileMeterLevelRowProps = {
  level: RulebookProfileMeterLevel;
  range: string;
  renderChip: RenderTokenChip;
  "data-testid"?: string;
};

const RulebookProfileMeterLevelRow = ({
  level,
  range,
  renderChip,
  "data-testid": testId = "RulebookProfileMeterLevelRow",
}: RulebookProfileMeterLevelRowProps) => (
  <div className="flex flex-col gap-1 border-0 border-t border-solid border-gray-6 dark:border-gray-8 px-3 py-2.5" data-testid={testId}>
    <div className="flex items-baseline gap-2">
      <Text variant={TextVariants.LABEL_MEDIUM_BOLD}>{level.label}</Text>
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="tabular-nums text-gray-10">
        {range}
      </Text>
    </div>
    {level.caption ? (
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-[13px] text-gray-11">
        “<RulebookTokenText text={level.caption} renderChip={renderChip} />”
      </Text>
    ) : null}
    {level.instruction ? (
      <div className="mt-0.5 flex gap-2 rounded-md bg-gray-3 p-2">
        <Icon icon={IconVariants.LIST_FILTER} size={IconSize.XSMALL} className="mt-0.5 flex-none text-gray-10" />
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-12">
          <RulebookTokenText text={level.instruction} renderChip={renderChip} />
        </Text>
      </div>
    ) : null}
  </div>
);

export default RulebookProfileMeterLevelRow;
